import React from 'react';
import { ZoomIn, ZoomOut, RotateCcw, Home, Maximize, ChevronsUpDown, ChevronsDownUp } from 'lucide-react';
import { Button } from '@/shared/components/ui/Button';

interface ChartToolbarProps {
  zoomLevel: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onZoomReset: () => void;
  onCenter: () => void;
  onFullscreen: () => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
  isFullscreen?: boolean;
}

export function ChartToolbar({
  zoomLevel,
  onZoomIn,
  onZoomOut,
  onZoomReset,
  onCenter,
  onFullscreen,
  onExpandAll,
  onCollapseAll,
  isFullscreen = false,
}: ChartToolbarProps) {
  return (
    <div className="flex items-center gap-1 text-xs text-[#747C9C]">
      <Button
        variant="ghost"
        size="icon"
        onClick={onZoomOut}
        className="h-7 w-7 rounded-md border border-[#E8E8F5] bg-[#FFFFFF] hover:bg-[#F2F2FA]"
        title="Zoom Out"
        aria-label="Zoom Out"
      >
        <ZoomOut className="h-3.5 w-3.5" />
      </Button>
      <span className="w-12 text-center text-[11px] font-semibold text-[#11183F]">{zoomLevel}%</span>
      <Button
        variant="ghost"
        size="icon"
        onClick={onZoomIn}
        className="h-7 w-7 rounded-md border border-[#E8E8F5] bg-[#FFFFFF] hover:bg-[#F2F2FA]"
        title="Zoom In"
        aria-label="Zoom In"
      >
        <ZoomIn className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={onZoomReset}
        className="h-7 w-7 rounded-md border border-[#E8E8F5] bg-[#FFFFFF] hover:bg-[#F2F2FA]"
        title="Reset Zoom"
        aria-label="Reset Zoom"
      >
        <RotateCcw className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={onCenter}
        className="h-7 w-7 rounded-md border border-[#E8E8F5] bg-[#FFFFFF] hover:bg-[#F2F2FA]"
        title="Center View"
        aria-label="Center View"
      >
        <Home className="h-3.5 w-3.5" />
      </Button>
      <Button
        variant="ghost"
        size="icon"
        onClick={onFullscreen}
        className="h-7 w-7 rounded-md border border-[#E8E8F5] bg-[#FFFFFF] hover:bg-[#F2F2FA]"
        title={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
        aria-label={isFullscreen ? 'Exit Fullscreen' : 'Fullscreen'}
      >
        <Maximize className="h-3.5 w-3.5" />
      </Button>
      <div className="mx-1 h-4 w-px bg-[#E8E8F5]" />
      <Button
        variant="outline"
        size="sm"
        onClick={onExpandAll}
        className="gap-1 px-2 py-1 text-[11px] border-[#E8E8F5] text-[#747C9C] hover:bg-[#F2F2FA]"
        title="Expand All"
        aria-label="Expand All"
      >
        <ChevronsUpDown className="h-3.5 w-3.5" />
        <span>Expand</span>
      </Button>
      <Button
        variant="outline"
        size="sm"
        onClick={onCollapseAll}
        className="gap-1 px-2 py-1 text-[11px] border-[#E8E8F5] text-[#747C9C] hover:bg-[#F2F2FA]"
        title="Collapse All"
        aria-label="Collapse All"
      >
        <ChevronsDownUp className="h-3.5 w-3.5" />
        <span>Collapse</span>
      </Button>
    </div>
  );
}